<header class="flex justify-end items-center gap-3 h-16 relative w-full mt-10">
  <div class="flex items-center gap-5">
    <div class="relative h-14 min-w-40" aria-label="Selecionar mês">
      <div class="h-14 pl-7 pr-3 rounded-full bg-lGray900 text-lWhite flex items-center gap-4 min-w-40 pointer-events-none">
        <span class="text-4.5 leading-none tracking-wide">{{ selectedMonthLabel }}</span>

        <span class="w-11 h-11 rounded-full bg-gradient-button flex items-center justify-center shrink-0">
          <l-icon class="text-white text-2xl leading-none">calendar_month</l-icon>
        </span>
      </div>

      <p-datepicker
        [(ngModel)]="selectedMonthDate"
        view="month"
        [readonlyInput]="true"
        appendTo="body"
        panelStyleClass="header-month-picker-panel"
        [showIcon]="false"
        inputStyleClass="!absolute !inset-0 !w-full !h-full !opacity-0 !cursor-pointer"
        styleClass="!absolute !inset-0 !w-full !h-full"
      />
    </div>

    <div class="flex items-center relative" aria-label="Notificações">
      <button type="button" class="relative cursor-pointer" (click)="toggleNotifications()" aria-label="Abrir notificações">
        <l-icon class="text-lWhite !text-3xl">notifications</l-icon>
        <span class="absolute -top-1 -right-1 min-w-5 h-5 rounded-full bg-lDanger text-white text-xs font-semibold leading-5 text-center px-1">3</span>
      </button>

      <button
        type="button"
        class="fixed inset-0 z-40 cursor-default"
        [class.hidden]="!notificationsOpen"
        aria-label="Fechar notificações"
        (click)="closeNotifications()"
      ></button>

      <div class="absolute right-0 top-14 z-50" [class.hidden]="!notificationsOpen">
        <l-notifications-modal></l-notifications-modal>
      </div>
    </div>
  </div>
</header>

<hr class="border-lGray700 w-full mt-4 mb-16" />
